import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CircularProgress, Box, Typography } from "@mui/material";
import Home from "./pages/Home";
import { motion } from "framer-motion"; // Voor animaties

function App() {
 
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
